<!--
  @description 业务上线申请单
  @author xiehan
  @date 2019/01/17
-->
<template>
    <div class="serviceOrder">
      <request-note
        ref="requestNote"
        @submitRequest="getRequestForm"
        submitButtonRac="serviceOrder@submit"
        :requestTitle="$t('cloudApplication.serviceRequest')"
        :assignee="assignee"
        :status="status"
        :requestInfo="requestInfo">
        <div slot="center">
          <el-table
            :data="tableData"
            border
            style="width: 100%;">
            <el-table-column
              prop="businessType"
              :label="$t('cloudApplication.businessType')">
            </el-table-column>
            <el-table-column
              prop="group"
              :label="$t('cloudApplication.group')">
            </el-table-column>
            <el-table-column
              prop="versionType"
              :label="$t('cloudApplication.versionType')">
            </el-table-column>
            <el-table-column
              prop="version"
              :label="$t('cloudApplication.versionNum')">
            </el-table-column>
            <el-table-column
              prop="releaseTime"
              :label="$t('cloudApplication.releaseTime')">
            </el-table-column>
          </el-table>
        </div>
        <div slot="footer">
          <el-form label-width="80px" v-if="!assignee && (status !== '6' && status !== '5')">
            <el-form-item :label="$t('cloudApplication.currentAssignee')">
              <span v-text="requestInfo.currentAssignee"></span>
            </el-form-item>
          </el-form>
          <el-table
            v-if="!assignee"
            :data="processTable"
            style="width: 100%">
            <el-table-column prop="operateTime" :label="$t('common.time')"></el-table-column>
            <el-table-column prop="node" :label="$t('queryworkOrder.node')"></el-table-column>
            <el-table-column prop="operator" :label="$t('queryworkOrder.operator')"></el-table-column>
            <el-table-column prop="operation" :label="$t('common.handle')"></el-table-column>
            <el-table-column prop="advise" :label="$t('queryworkOrder.advise')"></el-table-column>
          </el-table>
        </div>
      </request-note>
    </div>
  </template>
  
  <script>
    import dic from '@/components/mixins/dic'
    import requestNote from '@/views/component/requestNote/requestNote'
    import queryworkOrderBiz from '@/logic/workFlow/queryworkOrderBiz'
    import TimeFormat from '@/utils/timeFormat'
    export default {
      mixins: [dic],
      data () {
        return {
          status: '',
          select_business: {},
          select_group: {},
          select_version: {},
          select_site: {},
          select_operate: {},
          requestInfo: {},
          assignee: true,
          processTable: [],
          tableData: []
        }
      },
      components: {
        requestNote
      },
      methods: {
        init () {
          this.status = String(this.$route.query.status)
          this.assignee = String(this.$route.query.assignee) === '1'
          this.getDic()
        },
        getOrderInfoById () {
          queryworkOrderBiz.getTaskDetailById({
            processInstanceId: String(this.$route.query.orderId)
          }).then(data => {
            this.requestInfo = data.info
            this.requestInfo.site = this.select_site[this.requestInfo.site]
            this.requestInfo.date = TimeFormat.getFormatTime(this.requestInfo.date)
            this.requestInfo.expectedTime = TimeFormat.getFormatTime(this.requestInfo.expectedTime)
            this.processTable = data.record
            this.processTable.map(item => {
              item.operateTime = TimeFormat.getFormatTime(item.operateTime)
              item.operation = this.select_operate[item.operation]
            })
            this.tableData = []
            this.requestInfo.serviceInfoVO.map(item => {
              this.tableData.push({
                businessType: this.select_business[item.businessType],
                group: this.select_group[item.group],
                versionType: this.select_version[item.versionType],
                version: item.version,
                releaseTime: TimeFormat.getFormatTime(item.releaseTime)
              })
            })
          })
        },
        async getDic () {
          await Promise.all([
            this.dGetDictionaryByCode('businessType'),
            this.dGetDictionaryByCode('groupType'),
            this.dGetDictionaryByCode('versiontype'),
            this.dGetDictionaryByCode('remoteconfig'),
            this.dGetDictionaryByCode('workflowOperationType')
          ])
          this.select_business = { ...this.dDictionary.businessType }
          this.select_group = { ...this.dDictionary.groupType }
          this.select_version = { ...this.dDictionary.versiontype }
          this.select_site = { ...this.dDictionary.remoteconfig }
          this.select_operate = { ...this.dDictionary.workflowOperationType }
          this.getOrderInfoById()
        },
        getRequestForm (val) {
          let eventName
          let param = {}
          if (this.$route.query.status === '2') {
            eventName = 'businessApproveApply'
            param = { ...val }
          } else if (this.$route.query.status === '3') {
            eventName = 'businessExecute'
          }
          queryworkOrderBiz[eventName]({
            processInstanceId: this.$route.query.orderId, ...param
          }).then(data => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.$router.push({ name: 'queryworkOrder' })
          })
        }
      },
      watch: {
        $route (to, from) {
          if (to.name === 'serviceOrder' && from.name === 'queryworkOrder') {
            if (this.status === '5') {
              this.$nextTick(() => {
                this.$refs.requestNote.onStatus5()
              })
            } else {
              this.$refs.requestNote.init()
            }
            this.init()
          }
        }
      },
      mounted () {
        this.init()
        if (this.status === '5') {
          this.$nextTick(() => {
            this.$refs.requestNote.onStatus5()
          })
        }
      }
    }
  </script>
  
  <style scoped>

  </style>